module.exports = __webpack_public_path__ + "fblogo60.png?3c55699134f5e3e62ebd81a5a07571cc";